export default "/images/full_blue.png?21b6c9a35b830155b0077ec2b6fcf8e9";